<div @fadeIn class="loader">
  <ng-content></ng-content>
</div>

<div class="loader-backdrop" tabindex="-1"></div>
